<template>

  <v-card class="rounded-l">
    <v-card-title class="primary white--text">
      {{ location.company_name }}
    </v-card-title>
    <v-card-text class="pa-4">
      <v-list>
        <v-list-item>
          <v-list-item-icon><v-icon color="primary">mdi-map-marker</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              <span>{{ location.address_line_1 }}<br></span>
              <span v-if="location.address_line_2">{{ location.address_line_2 }}<br></span>
              <span v-if="location.address_line_3">{{ location.address_line_3 }}<br></span>
              <span>{{ location.city_locality }} {{ location.state_province }} {{ location.postal_code }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon><v-icon color="primary">mdi-phone</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              <span v-if="location.phone">{{ location.phone }}</span>
              <span v-else class="font-italic">Not recorded</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon><v-icon color="primary">mdi-email</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              <span v-if="location.email">{{ location.email }}</span>
              <span v-else class="font-italic">Not recorded</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-card-text>
  </v-card>

</template>

<style lang="scss" scoped>
</style>

<script>
//import { mapActions, mapGetters } from 'vuex'
//import Moment from '@/components/Moment'

export default {
  name: 'location',

  components: {
  },

  props: {
    location: { type: Object, required: true },
  },

  data: () => ({
  }),

  computed: {
  },

  watch:{
  },

  methods: {
  },

  mounted() {
  }
};
</script>
7